<template>
  <div>
    <!-- 顶部 -->
    <div class="box">
      <div class="left">
        <!-- logo -->
        <div class="logo" @click="$router.push({ name: 'home' })">{{ platformName.toUpperCase() }}
          <!-- <img src="../assets/img/logo_pc.png" alt="" /> -->
        </div>
        <!-- 首页 -->
        <div class="item" @click="$router.push({ name: 'Home' })">{{ $t('tabBar').home }}</div>
        <!-- 充值-->
        <el-popover placement="top-start" width="350" trigger="hover" popper-class="elpopper">
          <div class="leftInfos">
            <!-- 充币 -->
            <div class="item" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">
              <svg-icon class-name="ssvgs" icon-class="icon-deposit-usdt" />
              <div class="right">
                <div class="t1">{{ $t('common').Depositcoins }}</div>
                <div class="t2">{{ $t('common').DepositcoinsTips }}</div>
              </div>
            </div>
            <!-- C2C -->
            <div class="item" @click="$router.push({ name: 'C2c' })" v-if="!$store.state.isSim">
              <svg-icon class-name="ssvgs" icon-class="icon-c2c" />
              <div class="right">
                <div class="t1">C2C</div>
                <div class="t2">{{ $t('common').c2cTips }}</div>
              </div>
            </div>
            <!-- 法币入金 -->
            <!-- <div class="item" @click="$goRecharge('Recharge')" v-if="!$store.state.isSim">
              <svg-icon class-name="ssvgs" icon-class="icon-deposit-crypto" />
              <div class="right">
                <div class="t1">{{ $t('common').Rechargefiatcurrency }}</div>
                <div class="t2">{{ $t('common').RechargefiatcurrencyTips }}</div>
              </div>
            </div> -->
            <!-- 划转 -->
            <div class="item" @click="$router.push({ name: 'AssetTransfer' })">
              <svg-icon class-name="ssvgs" icon-class="icon-transfer" />
              <div class="right">
                <div class="t1">{{ $t('asset').Transfer }}</div>
                <div class="t2">{{ $t('common').TransferTips }}</div>
              </div>
            </div>
            <!-- 闪兑 -->
            <div class="item" @click="$router.push({ name: 'AssetFlashcash' })">
              <svg-icon class-name="ssvgs" icon-class="icon-convert" />
              <div class="right">
                <div class="t1">{{ $t('asset').flashcash }}</div>
                <div class="t2">{{ $t('common').TransferTips }}</div>
              </div>
            </div>
          </div>
          <div class="item" slot="reference">{{ $t('bill').recharge }}<van-icon name="play" size="15" class="ric" color="#ffffff" />
          </div>
        </el-popover>
        <!-- 行情 -->
        <div class="item" @click="$router.push({ name: 'Market' })">{{ $t('market').market }}</div>
        <!-- 合约-->
        <el-popover placement="top-start" width="300" trigger="hover" popper-class="elpopper">
          <div class="leftInfos">
            <!-- USDT合约 -->
            <div class="item" @click="toTrade(1)">
              <svg-icon class-name="ssvgs" icon-class="icon-usdt-rule" />
              <div class="right">
                <div class="t1">{{ $t('public').USDTcontract }}</div>
                <div class="t2">{{ $t('common').USDTcontractTips }}</div>
              </div>
            </div>
            <!-- 法币合约 -->
            <!-- <div class="item" @click="toTrade(2)">
              <svg-icon class-name="ssvgs" icon-class="icon-currency" />
              <div class="right">
                <div class="t1">{{ $t('public').Fiatcurrencycontract }}</div>
                <div class="t2">{{ $t('common').FiatcurrencycontractTips }}</div>
              </div>
            </div> -->
            <!-- 秒合约 -->
            <div class="item" @click="toTrade(4)">
              <svg-icon class-name="ssvgs" icon-class="icon-usdt-second" />
              <div class="right">
                <div class="t1">{{ $t('public').secondContract }}</div>
                <div class="t2">{{ $t('common').USDTcontractTips }}</div>
              </div>
            </div>
          </div>
          <div class="item" slot="reference"> {{ $t('asset').contract }}<van-icon name="play" size="15" class="ric" color="#ffffff" />
          </div>
        </el-popover>
        <!-- 理财 -->
        <el-popover placement="top-start" width="300" trigger="hover" popper-class="elpopper" v-if="!$store.state.isSim">
          <div class="leftInfos">
            <!-- 理财 -->
            <div class="item" @click="$router.push({ name: 'Finance' })">
              <svg-icon class-name="ssvgs2" icon-class="icon-finance" />
              <div class="right">
                <div class="t1">{{ $t('tabBar').heel }}</div>
                <div class="t2">{{ $t('home').SpottradingTips }}</div>
              </div>
            </div>
            <!-- 贷款 -->
            <div class="item" @click="$router.push({ name: 'Loan' })" v-if="isOpenLoan">
              <svg-icon class-name="ssvgs2" icon-class="icon-loan" />
              <div class="right">
                <div class="t1">{{ $t('finance').loan }}</div>
                <div class="t2">{{ $t('finance').loanTTips }}</div>
              </div>
            </div>
          </div>
          <div class="item" slot="reference"> {{ $t('tabBar').heel }}<van-icon name="play" size="15" class="ric" color="#ffffff" />
          </div>
        </el-popover>
        <!-- 现货 -->
        <div class="item" @click="toTrade(3)">{{ $t('public').spot }}</div>
        <!-- 福利 -->
        <!-- <div class="item" @click="$router.push({ name: 'Activity' })">{{ $t('activity').toptit }}</div> -->
        <!-- 客服 -->
        <div class="item" @click="goServe">{{ $t('common').customer }}</div>
        <!-- 新闻 -->
        <!-- <div class="item" @click="$router.push({ name: 'Notice' })">{{ $t('common').Notice }}</div> -->
      </div>
      <div class="right">
        <!-- 充值 -->
        <!-- <div class="regbtn" @click="$goRecharge('RechargeCurrency')" v-if="userShow&&!$store.state.isSim"> {{ $t('bill').recharge }}</div> -->
        <!-- 资产-->
        <el-popover placement="top-end" width="300" trigger="hover" popper-class="elpopper">
          <div class="commonInfos">
            <div class="assetInfo" @click="$router.push({ name: 'Asset' })">
              <div class="atxt">{{ $t('asset').Totalassetvaluation }}（USDT） <van-icon name="eye-o" color="#ffffff" size="15" v-if="isShow" @click.stop="isShow = false" />
                <van-icon name="closed-eye" color="#ffffff" size="15" v-else @click.stop="isShow = true" />
              </div>
              <div class="anum" v-if="isShow">{{ propertyVo.totalAmount }}</div>
              <div class="atxt" v-if="isShow">≈USD${{ propertyVo.totalAmount }}</div>
              <div class="anum" v-if="!isShow">{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}</div>
              <div class="atxt" v-if="!isShow">≈USD${{ propertyVo.totalAmount.toString().replace(/./g, '*') }}</div>
            </div>
            <div class="Info">
              <!-- 充币 -->
              <div class="item" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">
                <div class="left">
                  <i class="iconfont icon-deposit-crypto"></i>
                  <span>{{ $t('common').Depositcoins }}</span>
                </div>
              </div>
              <!-- 法币入金 -->
              <!-- <div class="item" @click="$goRecharge('Recharge')" v-if="!$store.state.isSim">
                <div class="left">
                  <i class="iconfont icon-deposit-usdt"></i>
                  <span>{{ $t('common').Rechargefiatcurrency }}</span>
                </div>
              </div> -->
              <!-- 划转 -->
              <div class="item" @click="$router.push({ name: 'AssetTransfer' })">
                <div class="left">
                  <i class="iconfont icon-transfer"></i>
                  <span>{{ $t('asset').Transfer }}</span>
                </div>
              </div>
              <!-- 闪兑 -->
              <div class="item" @click="$router.push({ name: 'AssetFlashcash' })">
                <div class="left">
                  <i class="iconfont icon-convert"></i>
                  <span>{{ $t('asset').flashcash }}</span>
                </div>
              </div>
              <!-- 提币 -->
              <div class="item" @click="$router.push({ name: 'WithCurrency' })" v-if="!$store.state.isSim">
                <div class="left">
                  <i class="iconfont icon-withdrawal-crypto"></i>
                  <span>{{ $t('bill').withdrawal_currency }}</span>
                </div>
              </div>
              <!-- 提现 -->
              <!-- <div class="item" @click="$router.push({ name: 'With' })" v-if="!$store.state.isSim">
                <div class="left">
                  <i class="iconfont icon-withdrawal-usdt"></i>
                  <span>{{ $t('bill').withdrawal }}</span>
                </div>
              </div> -->
              <!-- 资金明细 -->
              <div class="item" @click="$router.push({ name: 'Bill' })">
                <div class="left">
                  <i class="iconfont icon-funds"></i>
                  <span>{{ $t('common').Detailsoffunds }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item" slot="reference" v-if="userShow">{{ $t('tabBar').asset }}<van-icon name="play" size="15" class="ric" color="#ffffff" />
          </div>
        </el-popover>
        <!-- 已登录 个人中心-->
        <el-popover placement="top-end" width="300" trigger="hover" popper-class="elpopper">
          <div class="userInfos">
            <div class="uinfo">
              <div class="head" @click="$router.push({ name: 'Head' })">
                <img v-if="userInfo.avatar" :src="baseUrl + userInfo.avatar" />
                <img v-else src="@/assets/img/heard.png" />
              </div>
              <div class="utxt">
                <div class="name"><span>{{ userInfo.memberName }}</span></div>
                <div class="id">UID: <span @click="onCopy(userInfo.memberId)">{{ userInfo.memberId }} <i class="iconfont icon-copy" style="font-size: 14px;"></i></span></div>
                <div class="lable">
                  <div class="cert" v-if="userInfo.authenticationStatus == '4'"><svg-icon class-name="svgs" icon-class="cert" />
                    <span>{{ $t('user').authenticated }}</span>
                  </div>
                  <div class="ncert" v-else><svg-icon class-name="svgs" icon-class="cert" /> <span>{{
                    $t('user').Notcertifiedyet
                      }}</span></div>
                  <div class="vip">{{ $t('user').trustscore }}:
                    <span>{{ userInfo.trustScore }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 功能 -->
            <div class="Info">
              <!-- VIP -->
              <!-- <div class="item2">
                <div class="left">
                  <i class="iconfont icon-vip"></i>
                  <span>VIP0</span>
                </div>
                <div>
                  <van-icon name="arrow" size="18" color="var(--ntext_color)" />
                </div>
              </div> -->
              <!-- 邀请好友 -->
              <!-- <div class="item" @click="$router.push({ name: 'Share' })">
                <div class="left">
                  <svg-icon class-name="svgs" icon-class="share" />
                  <span>{{ $t('user').Invitefriends }}</span>
                </div>
              </div> -->
              <!-- 活动中心 -->
              <!-- <div class="item" @click="$toast($t('heel').tips)">
                <div class="left">
                  <svg-icon class-name="svgs" icon-class="activity" />
                  <span>{{ $t('user').Activecenter }}</span>
                </div>
              </div> -->
              <!-- 初级认证 -->
              <div class="item" @click="$router.push({ name: 'Auth' })">
                <div class="left">
                  <i class="iconfont icon-authentication"></i>
                  <span>{{ $t('auth').base }}</span>
                </div>
                <div>
                  <span v-if="userInfo.authenticationStatus == '2'||userInfo.authenticationStatus == '4'">{{ $t('user').Completedverification }}</span>
                  <span v-else>{{ $t('user').Tobeverified }}</span>
                </div>
              </div>
              <!-- 高级认证 -->
              <div class="item" @click="$router.push({ name: 'HighAuth' })">
                <div class="left">
                  <i class="iconfont icon-authentication"></i>
                  <span>{{ $t('auth').high }}</span>
                </div>
                <div>
                  <span v-if="userInfo.authenticationStatus == '4'">{{ $t('user').Completedverification }}</span>
                  <span v-else>{{ $t('user').Tobeverified }}</span>
                </div>
              </div>
              <!-- 资产认证 -->
              <div class="item" @click="$router.push({ name: 'AssetAuth' })">
                <div class="left">
                  <i class="iconfont icon-msg-asset"></i>
                  <span>{{ $t('auth').AssetCertification }}</span>
                </div>
              </div>
              <!-- 安全设置 -->
              <div class="item" @click="$router.push({ name: 'Safe' })">
                <div class="left">
                  <i class="iconfont icon-account-security"></i>
                  <span>{{ $t('user').SecuritySettings }}</span>
                </div>
              </div>
              <!-- 持仓明细 -->
              <div class="item" @click="$router.push({ name: 'Position' })">
                <div class="left">
                  <i class="iconfont icon-reports"></i>
                  <span>{{ $t('common').Positiondetails }}</span>
                </div>
              </div>
              <!-- 模拟交易 -->
              <div class="item">
                <div class="left">
                  <i class="iconfont icon-demo-trade"></i>
                  <span>{{ $t('trade').simulatedTrading }}</span>
                </div>
                <van-switch v-model="isSim" active-color="var(--text_color)" inactive-color="var(--ntext_color)" size="15px" @change="changeSimTade" />
              </div>
              <!-- 客服 -->
              <div class="item" @click="goServe">
                <div class="left">
                  <svg-icon class-name="svgs" icon-class="service" />
                  <span>{{ $t('common').customer }}</span>
                </div>
              </div>
              <!-- 帮助中心 -->
              <div class="item" @click="goServe">
                <div class="left">
                  <svg-icon class-name="svgs" icon-class="help" />
                  <span>{{ $t('user').helpcenter }}</span>
                </div>
              </div>
              <!-- 关于我们 -->
              <div class="item" @click="$router.push({ name: 'About' })">
                <div class="left">
                  <svg-icon class-name="svgs" icon-class="about" />
                  <span>{{ $t('user').Aboutus }}</span>
                </div>
              </div>
              <!-- 退出登录 -->
              <div class="item" @click="Logout">
                <div class="left">
                  <i class="iconfont icon-logout"></i>
                  <span>{{ $t('user').out }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="user" slot="reference" v-if="userShow">
            <i class="iconfont icon-user"></i>
          </div>
        </el-popover>
        <!-- 未登录 -->
        <div class="user_F" v-if="!userShow">
          <div class="user_in" @click="$router.push({ name: 'Login' })">
            <div class="u_txt_in">{{ $t('login').btn }}</div>
          </div>
          <div class="user_no" @click="$router.push({ name: 'Register' })">
            <div class="u_txt_no">
              {{ $t('register').btn }}
            </div>
          </div>
        </div>
        <!-- 公告 -->
        <div style="margin-right: 25px;">
          <van-badge dot>
            <i class="iconfont icon-bell" @click="$router.push({ name: 'Notice' })"></i>
          </van-badge>
        </div>
        <!-- 下载-->
        <el-popover placement="top-end" width="220" trigger="hover" popper-class="elpopper">
          <div class="qrcode">
            <qrcode-vue :value="qrcodeUrl" :size="160" level="H" class="qrimg"></qrcode-vue>
            <div class="tips">{{ $t('home').Scandownload }} {{ platformName }} App</div>
          </div>
          <div class="common" slot="reference">
            <i class="iconfont icon-download"></i>
          </div>
        </el-popover>
        <!-- 语言 -->
        <div class="translate">
          <el-dropdown @command="onSelect">
            <i class="iconfont icon-earth"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="index" v-for="(item, index) in lang_list" :key="index">{{ item.text
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!-- 皮肤 -->
        <div class="theme" @click="changeTheme">
          <i class="iconfont icon-theme-dark" v-if="theme == 'dark'"></i>
          <i class="iconfont icon-theme-light" v-else></i>
        </div>
      </div>
    </div>
    <!-- 取款选择 -->
    <van-popup v-model="showWithSelect" position="center" style="width: 400px;" closeable>
      <div class="withSelInfo">
        <div class="tit">{{ $t('common').Withdraw }}</div>
        <div class="tabs" @click="$router.push({ name: 'WithCurrency' })">{{ $t('common').Cryptocurrencywithdrawal }}
          <span><van-icon name="arrow" size="15" color="#a3a3a5" /></span>
        </div>
        <div class="tabs" @click="$router.push({ name: 'With' })">{{ $t('common').Fiatmoneywithdrawal }}<span><van-icon name="arrow" size="15" color="#a3a3a5" /></span></div>
      </div>
    </van-popup>
    <!-- 充值选择 -->
    <van-popup v-model="showRechargeSelect" position="center" style="width: 400px;" closeable>
      <div class="withSelInfo">
        <div class="tit">{{ $t('bill').recharge }}</div>
        <div class="tabs" @click="$goRecharge('RechargeCurrency')">{{ $t('common').Depositcoins }}
          <span><van-icon name="arrow" size="15" color="#a3a3a5" /></span>
        </div>
        <div class="tabs" @click="$goRecharge('Recharge')">{{ $t('common').Rechargefiatcurrency
        }}<span><van-icon name="arrow" size="15" color="#a3a3a5" /></span></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Token } from '@/utils/mm'
import { EventBus } from '@/utils/event-bus'
import { mapGetters } from 'vuex'
import userApi from '@/api/user'
import systemApi from '@/api/system'
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'pcTop',
  components: {
    QrcodeVue
  },
  data() {
    return {
      platformName: localStorage.getItem('platformName'),
      showRechargeSelect: false,
      showWithSelect: false,
      baseUrl: window.baseURL,
      theme: localStorage.getItem('theme'),//主题颜色
      userInfo: { balance: 0 },
      userShow: true,//用户是否登录
      lang_list: [
        { text: 'English', lang: 'en' },//英语
        { text: '繁體中文', lang: 'zh' },//繁体中文
        { text: '日本語', lang: 'jp' },//日语
        { text: '한국인', lang: 'hy' },//韩语
        { text: 'ภาษาไทย', lang: 'ty' },//泰语
        { text: 'Indonesia', lang: 'yn' },//印尼语
        { text: 'Việt nam', lang: 'yuenan' },//越南文
        { text: 'Français', lang: 'fy' },//法语
        { text: 'Español', lang: 'xby' },//西班牙语
        { text: 'Türkçe', lang: 'tr' },//土耳其语
        // { text: 'Русский язык', lang: 'ey' },//俄语
        // { text: 'Português', lang: 'pty' },//葡萄牙语
        // { text: 'Deutsch', lang: 'dy' },//德语
        // { text: 'កម្ពុជា', lang: 'gmw' },//高棉文
      ],
      langTxt: 'English',
      qrcodeUrl: '',
      propertyVo: {},
      isShow: true,
      isOpenLoan: false,
    }
  },
  computed: {
    ...mapGetters(['basicConfig', 'lang', 'connection']),
    onRoutes() {
      const route = this.$route
      const { meta, path } = route
      console.log(meta.activeMenu)
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    isSim: {
      get() {
        return this.$store.state.isSim
      },
      set(value) {
        this.$store.commit('setSim', value)
      }
    }
  },

  mounted() {
    //事件消息监听
    EventBus.$on('user', (value) => {
      this.userShow = value
    })
    this.lang_int()
    this.getConfig()
    //获取用户信息
    if (Token.get()) {
      this.getMemberInfo()
      this.getPropertyInfo()
    } else
      this.userShow = false
  },
  methods: {
    // 切换模拟交易
    async changeSimTade() {
      if (this.$store.state.isSim)
        await userApi.initSimTrade()
      this.getPropertyInfo()
    },
    // 获取配置
    async getConfig() {
      const res = await systemApi.getConfig()
      this.qrcodeUrl = res.systemSetting.qrcodeUrl
      this.isOpenLoan = res.systemSetting.isOpenLoan
    },
    //获取资产统计
    async getPropertyInfo() {
      const res = await userApi.getPropertyInfo({ type: 0 })
      this.propertyVo = res.data
    },
    //跳转交易
    toTrade(val) {
      if (this.$route.name == 'Trade') {
        EventBus.$emit('tradeType', val)
        return
      }
      if (val)
        this.$router.push({ name: 'Trade', query: { type: val } })
      else
        this.$router.push({ name: 'Trade' })
    },
    // 更换主题颜色
    changeTheme() {
      var theme = this.theme == 'dark' ? '' : 'dark'
      localStorage.setItem('theme', theme)
      EventBus.$emit('theme', theme)
      EventBus.$emit('loadChat')
      this.theme = theme
      this.checked = localStorage.getItem('theme') == ''
    },
    // 客服
    async goServe() {
      // const res = await systemApi.getConfig()
      // location.href = res.systemSetting.serviceUrl
      const res = await userApi.getMemberInfo()
      const encodedData = JSON.stringify({ name: res.user.memberId, email: res.user.memberName });
      location.href = 'chatlinkonline.html?metadata=' + encodedData
    },
    // 隐私协议
    async goAgreement() {
      const res = await systemApi.getContentList({ type: '0' })
      this.$router.push({ name: 'Detail', query: { id: res.rows[0].contentLocalizationId } })
    },
    //语言初始化
    lang_int() {
      this.lang_list.forEach((item, index, arr) => {
        if (item.lang == localStorage.getItem('language'))
          this.langTxt = item.text
      })
    },
    // 获取用户信息
    async getMemberInfo() {
      const res = await userApi.getMemberInfo()
      this.userInfo = res.user
      this.userShow = true
    },
    //退出登录
    Logout() {
      this.$dialog.confirm({
        title: this.$t('user').outmsg,
        confirmButtonText: this.$t('public').confirm,
        confirmButtonColor: 'var(--primary_color)',
        cancelButtonText: this.$t('public').cancel,
        cancelButtonColor: 'var(--ntext_color)',
      })
        .then(() => {
          Token.remove()
          this.userShow = false
        })
    },
    //复制方法
    onCopy(text) {
      return new Promise((resolve) => {
        if (navigator.clipboard?.writeText) {
          this.$toast(this.$t('public').copySuccess)
          return resolve(navigator.clipboard.writeText(text))
        }
        const textarea = document.createElement('textarea')
        document.body.appendChild(textarea)
        textarea.style.position = 'absolute'
        textarea.style.clip = 'rect(0 0 0 0)'
        textarea.value = text
        textarea.select()
        document.execCommand('copy', true)
        textarea.remove()
        this.$toast(this.$t('public').copySuccess)
        return resolve(true)
      })
    },
    /* 语言切换 */
    onSelect(index) {
      const lang = this.lang_list[index].lang
      this.$i18n.locale = lang
      this.$store.commit('SET_LANG', lang)
      localStorage.setItem('language', lang)
      EventBus.$emit('loadChat')
      this.lang_int()
    }
  }
}
</script>
<style lang="less" scoped>
* {
  .svgs {
    width: 22px;
    height: 22px;
    color: #ffffff;
  }

  .svgsss {
    width: 20px;
    height: 20px;
    color: #ffffff;

    &:hover {
      opacity: 0.8;
    }
  }

  .svgs:hover {
    opacity: 0.8;
  }
  .iconfont:hover {
    color: var(--primary_color);
  }
}

.box {
  height: 56px;
  z-index: 100;
  left: 0;
  top: 0;
  position: fixed;
  background: #0f0f0f;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;

  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      width: auto;
      height: 56px;
      font-size: 27px;
      font-weight: bold;
      color: #ffffff;
      display: flex;
      align-items: center;
      margin-right: 25px;

      img {
        height: 56px;
        width: 171px;
      }
    }

    .item {
      padding: 0 13px;
      display: flex;
      align-items: center;
      height: 56px;
      font-size: 15px;
      color: #ffffff;

      .ric {
        transform: rotate(90deg);
        margin-left: 5px;
      }
    }

    .item:hover {
      padding: 0 13px;
      display: flex;
      align-items: center;
      height: 56px;
      color: var(--primary_color);
      background: #2b2a2a;

      .ric {
        color: var(--primary_color) !important;
        transform: rotate(270deg);
        margin-left: 5px;
      }
    }
  }

  .right {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .item {
      padding: 0 13px;
      display: flex;
      align-items: center;
      height: 56px;
      font-size: 15px;
      color: #ffffff;

      .ric {
        transform: rotate(90deg);
        margin-left: 5px;
      }
    }

    .item:hover {
      padding: 0 13px;
      display: flex;
      align-items: center;
      height: 56px;
      color: var(--primary_color);
      background: #2b2a2a;

      .ric {
        color: var(--primary_color) !important;
        transform: rotate(270deg);
        margin-left: 5px;
      }
    }

    .regbtn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      background: #ffffff;
      padding: 8px 16px;
      border-radius: 30px;
      font-size: 15px;
      color: #1b1b1b;
    }

    .regbtn:hover {
      opacity: 0.8;
    }

    .common {
      height: 56px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 25px;
    }

    .user {
      height: 56px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 25px;
      margin-left: 10px;
    }

    .user_F {
      display: flex;
      margin-left: 10px;

      .user_in {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 20px;
        background: var(--primary_color);
        padding: 10px 20px;
        border-radius: 5px;

        .u_txt_in {
          font-size: 15px;
          color: #ffffff;
        }
      }

      .user_in:hover {
        opacity: 0.8;
      }

      .user_no {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 20px;
        background: var(--background_color);
        padding: 10px 20px;
        border-radius: 5px;

        .u_txt_no {
          font-size: 15px;
          color: var(--text_color);
        }
      }

      .user_no:hover {
        opacity: 0.8;
      }
    }

    .translate {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 56px;
      margin-right: 25px;

      .el-dropdown-link {
        font-size: 14px;
        color: #ffffff;
      }

      .el-dropdown-link:hover {
        opacity: 0.8;
      }
    }
  }
}

//左侧功能详细
.leftInfos {
  padding: 15px;

  .item {
    display: flex;
    padding: 15px;

    .ssvgs {
      margin-top: 2px;
      width: 24px;
      height: 24px;
      color: #ffffff;
    }

    .ssvgs2 {
      margin-top: 2px;
      width: 30px;
      height: 30px;
      color: #ffffff;
    }

    .right {
      margin-left: 15px;
      width: 260px;

      .t1 {
        font-size: 15px;
        color: #ffffff;
      }

      .t2 {
        margin-top: 5px;
        font-size: 13px;
        color: #a3a3a5;
      }
    }

    &:hover {
      background: #2b2a2a;
      border-radius: 10px;
    }
  }
}

//常用功能
.commonInfos {
  .assetInfo {
    margin: 15px;
    padding: 15px;
    border-radius: 10px;
    background: #2b2a2a;

    .anum {
      font-size: 25px;
      font-weight: 800;
      color: #ffffff;
    }

    .atxt {
      font-size: 12px;
      font-weight: normal;
      color: #a3a3a5;
    }
  }

  .Info {
    padding-bottom: 10px;

    .item {
      padding: 15px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:hover {
        background: #2b2a2a;
      }

      .svgs {
        width: 21px;
        height: 21px;
        color: #ffffff;
      }

      .left {
        display: flex;
        align-items: center;

        span {
          margin-left: 15px;
          font-size: 15px;
          color: #ffffff;
        }
      }
    }
  }
}

//下载
.qrcode {
  padding: 20px 20px 0 20px;

  .qrimg {
    width: 180px;
    height: 180px;
    padding: 10px;
    background: #fff;
    border-radius: 10px;
  }

  .tips {
    margin: 10px 0 20px 0;
    text-align: center;
    font-size: 14px;
    color: #a3a3a5;
  }
}

//个人中心
.userInfos {
  .uinfo {
    display: flex;
    align-items: center;
    padding: 20px;

    .head {
      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
    }

    .utxt {
      margin-left: 10px;
      width: 215px;

      .name {
        color: #ffffff;
        font-size: 18px;
        font-weight: bold;
      }

      .id {
        margin-top: 5px;
        color: #ffffff;
        font-size: 14px;

        span {
          font-weight: bold;
        }
      }

      .csvgs {
        width: 15px;
        height: 15px;
        color: #a3a3a5;
      }

      .lable {
        margin-top: 10px;
        display: flex;
        align-items: center;

        .cert {
          font-size: 13px;
          color: #2dbd84;
          display: flex;
          align-items: center;

          .svgs {
            width: 18px;
            height: 18px;
            color: #2dbd84;
            margin-right: 5px;
          }
        }

        .ncert {
          font-size: 13px;
          color: #a3a3a5;
          display: flex;
          align-items: center;

          .svgs {
            width: 18px;
            height: 18px;
            color: #a3a3a5;
            margin-right: 5px;
          }
        }

        .vip {
          margin-left: 10px;
          font-size: 13px;
          color: #ffffff;
        }
      }
    }
  }

  .Info {
    padding-bottom: 10px;

    .item {
      padding: 15px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:hover {
        background: #2b2a2a;
      }

      .svgs {
        width: 21px;
        height: 21px;
        color: #ffffff;
      }

      .left {
        display: flex;
        align-items: center;

        span {
          margin-left: 15px;
          font-size: 15px;
          color: #ffffff;
        }
      }

      span {
        margin-left: 10px;
        font-size: 13px;
        color: #a3a3a5;
      }
    }

    .item2 {
      margin: 0 20px 15px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #2b2a2a;
      padding: 10px;
      border-radius: 5px;

      &:hover {
        background: #353434;
      }

      .svgs {
        width: 21px;
        height: 21px;
        color: #ffffff;
      }

      .left {
        display: flex;
        align-items: center;

        span {
          margin-left: 15px;
          font-size: 15px;
          color: #fea600;
          font-weight: bold;
        }
      }
    }
  }
}

//注册弹框
.sign_info {
  width: 100%;
  padding: 36px 25px 25px 25px;
  background: #1b1b1b;
  border-radius: 15px;

  .si_r_top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .si_r_t_title {
      font-weight: bold;
      font-size: 22px;
      color: #ffffff;
      line-height: 24px;
    }
  }

  .si_r_tab {
    margin-top: 20px;
    display: flex;
    justify-content: left;
    font-weight: 400;
    font-size: 15px;
    color: #ffffff;
    line-height: 24px;

    .si_r_b_btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 140px;
      height: 39px;
    }

    .active {
      background: #a3a3a5;
      border-radius: 25px;
      color: #fff;
    }
  }

  .sign_phone_select {
    margin-left: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    color: #ffffff;

    .line {
      margin-left: 10px;
      height: 20px;
      width: 1px;
      background: #ffffff;
    }
  }

  .sign_phone_btn {
    margin: 9px 20px 0 0;
    border-radius: 3px;
    font-size: 15px;
    color: #a3a3a5;
    line-height: 24px;
  }

  .sign_btn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    background: #a3a3a5;
    border-radius: 25px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #ffffff;
    line-height: 24px;
  }

  .si_r_t_msg {
    margin-top: 10px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    line-height: 24px;

    span {
      color: #a3a3a5;
      text-decoration: underline;
    }
  }
}

//登录弹框
.login_info {
  width: 100%;
  padding: 36px 25px 25px 25px;
  background: #1b1b1b;
  border-radius: 15px;

  .si_r_top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .si_r_t_title {
      font-weight: bold;
      font-size: 22px;
      color: #ffffff;
      line-height: 24px;
    }
  }

  .si_r_tab {
    margin-top: 20px;
    display: flex;
    justify-content: left;
    font-weight: 400;
    font-size: 15px;
    color: #ffffff;
    line-height: 24px;

    .si_r_b_btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 140px;
      height: 39px;
    }

    .active {
      background: #a3a3a5;
      border-radius: 25px;
      color: #fff;
    }
  }

  .passInfo {
    margin: 10px 10px 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #ffffff;
    font-size: 14px;
  }

  .login_btn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    background: #a3a3a5;
    border-radius: 25px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #ffffff;
    line-height: 24px;
  }

  .agree {
    margin-top: 10px;
    color: #a3a3a5;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      margin-left: 5px;
    }
  }

  .si_r_t_msg {
    margin-top: 10px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;

    span {
      color: #a3a3a5;
      text-decoration: underline;
    }
  }
}

//认证弹框
.auth_info {
  width: 100%;
  padding: 50px 25px 50px 25px;

  img {
    width: 100px;
    height: 40px;
  }

  .auth_img {
    width: 100px;
    display: flex;
    align-items: center;
    margin: 6px 10px 0 10px;
  }

  .auth_btn {
    margin: 30px 0 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    background: #2b3154;
    border-radius: 3px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #ffffff;
    line-height: 24px;
  }
}

.withSelInfo {
  padding: 20px;

  .tit {
    margin-bottom: 30px;
    text-align: center;
    font-size: 21px;
    font-weight: bold;
    color: #ffffff;
  }

  .tabs {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    background: #000;
    border-radius: 10px;
    padding: 20px;
  }

  .tabs:hover {
    opacity: 0.8;
  }
}

::v-deep .van-popup--center {
  border-radius: 15px;
  background: #1b1b1b;
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: #a3a3a5;
}

//下拉框
::v-deep .el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: #1b1b1b;
  color: #ffffff;
  opacity: 0.8;
}

.el-dropdown-menu {
  margin-top: 25px !important;
  background-color: #1b1b1b;
  padding: 5px 12px;
  text-align: center;
  color: #ffffff;
  border-radius: 0 0 15px 15px;
  border: none;
}

.el-dropdown-menu__item {
  color: #ffffff;
}

/* 消除小三角 */
::v-deep .popper__arrow {
  display: none;
}

.el-icon-arrow-down {
  font-size: 14px;
  margin-left: 10px;
}

// 设置输入框的背景色、字体颜色、边框属性设置；
::v-deep .el-form--label-top .el-form-item__label {
  padding: 0;
}

::v-deep .el-form-item__content {
  line-height: 50px;
  margin-top: 15px;
}

::v-deep .el-form-item__label {
  font-size: 14px;
  color: #ffffff;
}

::v-deep .el-input__inner {
  border-radius: 25px;
  border: none;
  font-size: 15px;
  color: #ffffff;
  height: 50px;
  line-height: 50px;
  background: #000000;
}

::v-deep .el-input__inner::placeholder {
  color: #ffffff;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 80px;
}

::v-deep .el-input--suffix .el-input__inner {
  padding-right: 150px;
}

// 弹出框
::v-deep .el-dialog {
  border-radius: 20px;
}

::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .el-dialog__body {
  padding: 0;
}

::v-deep .van-checkbox__label {
  margin-left: 5px;
  color: #ffffff;
  font-size: 14px;
}

::v-deep .van-badge {
  border: none;
}

::v-deep .van-badge--dot {
  background-color: #ff493d;
  width: 6px;
  height: 6px;
}
</style>
<style>
.elpopper {
  margin-top: 0px !important;
  padding: 0;
  background: #1b1b1b;
  border-radius: 0 0 15px 15px;
  /* border: 1px solid rgba(100, 116, 139, 0.3); */
  border: none;

  .popper__arrow {
    display: none;
  }
}
</style>